<template>
<div>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'HALO',
            icon: 'fas fa-layer-group text-ao-light',
          }"
        >
          <sidebar-item
            v-for="section in getScenario.allSections"
            :key="section"
            :link="{ name: section, path: `/dashboard/${getSelectedLoanId}/${section}`}"
            @click.native="setSelectedSectionName(section)"
            :data-test="`section-link-${section}`"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Tools',
            icon: 'fas fa-tools text-ao-dark',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Adjustments',
              path: `/adjustments/${getSelectedLoanId}`
            }"
            data-test="section link"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Compare Scenarios',
              path: `/compare/${getSelectedLoanId}`
            }"
            data-test="section link"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Compensating Factors',
              path: `/compensatingFactors/${getSelectedLoanId}`
            }"
            data-test="section link"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
        :link="{
          name: 'Scenario Tool',
          icon: 'fas fa-search text-ao-light',
        }"
        >
          <sidebar-item
            v-for="section in getScenario.allSections"
            :key="section"
            :link="{ name: section, path: `/scenarioTool/${getSelectedLoanId}/${section}`}"
            @click.native="setSelectedSectionName(section)"
            :data-test="`section-link-${section}`"
          ></sidebar-item>
        </sidebar-item>
      </template>

      <template slot="links-after">
      </template>
    </side-bar>
    <div class="main-content">
      <side-bar-header :type="$route.meta.navbarType"></side-bar-header>
      <div @click="$sidebar.displaySidebar(false)">
        <base-header class="pb-6 bg-gradient-info border-bottom">
          <transition name="disappear" mode="out-in">
            <!--stat cards -->
            <stat-cards v-if="this.$route.name !== 'scenarioTool'"></stat-cards>
          </transition>
          <transition name="alert-fade" mode="out-in">
            <notifications id="not-saved" v-if="(!getSaved && getHasRun) && this.$route.name !== 'scenarioTool'"></notifications>
          </transition>
        </base-header>

        <b-container fluid class="mt--5">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
        </b-container>
        <transition name="alert-fade" mode="out-in">
          <notifications id="not-saved" v-if="(!getSaved && getHasRun) && this.$route.name !== 'scenarioTool'"></notifications>
        </transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
  
</div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import SideBarHeader from './SideBarHeader';
  import ContentFooter from './ContentFooter';
  import StatCards from './StatCards';
  import { mapGetters, mapMutations } from 'vuex';
  // import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      SideBarHeader,
      ContentFooter,
      StatCards
      // FadeTransition
    },
    methods: {
      ...mapMutations(["setSelectedSectionName"]),
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      },
      
    },
    computed: {
      ...mapGetters([
        "getScenario",
        "getSelectedLoanId",
        "getSaved",
        "getHasRun"
      ]),
    },
    
    mounted() {
      this.initScrollbar();
      this.$notify({
        verticalAlign: 'top',
        horizontalAlign: 'center',
        title: 'The scenario is not saved.',
        closeOnClick: false,
        timeout: null,
        type: 'danger'
      });
    }
  };
</script>
<style>
.border-bottom {
  border-bottom-style: none !important;
}
.notifications .alert {
  position: relative !important;
  top: 0px !important;
  margin-top: -10px !important;
  margin-bottom: -15px !important;
}

.fade-enter-active {
  transition: all ease;
  opacity: 0;
  transform: translateY(5px);
}

.fade-enter-to {
  transition: all .3s ease;
  opacity: 1;
  transform:translateY(0);
}

.fade-leave-to {
  transition: all ease;
  opacity: 0;
}

.fade-leave-active {
  transition: all .3s ease;
  transform:translateY(5px);
}

.disappear-enter-active {
  transition: all;
  opacity: 0;
  transform: translateY(5px);
}

.disappear-enter-to {
  transition: all .275s;
  opacity: 1;
  transform:translateY(0);
}

.disappear-leave-to {
  transition: all;
  opacity: 0;
}

.disappear-leave-active {
  transition: all .275s;
  transform:translateY(5px);
}

.invalid {
  text-decoration: bold;
  color: red;
}
</style>
